/**
 * Interruptor único de MercadoPago como canal de venta en el front.
 *
 * Apagado por decisión de producto (2026-09-13). La cuenta MercadoPago de la
 * marca no cobró ninguna venta desde el alta del proyecto: lo que entra son
 * transferencias personales y fondeo propio, y las 11 suscripciones creadas
 * quedaron todas en `pending`, nunca autorizadas. Dejar los CTA vivos manda
 * gente a un checkout que no cobra.
 *
 * Argentina, que era el único país servido por MercadoPago, deja de tener
 * camino de pago: los CTA se ocultan en vez de apuntar a un checkout muerto.
 * No se cae a Stripe — `api/lib/argentinaStripeGuard.ts` lo bloquea a
 * propósito, y a qué cuenta entra la plata no es una decisión de este archivo.
 *
 * Para reactivarlo: `VITE_MP_SALES_ENABLED=true` en el build. Es build-env y no
 * edge config a propósito: prender un cobro merece un deploy, no un toggle.
 *
 * Esto apaga la VENTA, no la lectura: el admin, la conciliación y el reporte de
 * P&L siguen leyendo lo que MercadoPago ya registró.
 */

export function isMercadoPagoSalesEnabled(): boolean {
  const raw = import.meta.env?.VITE_MP_SALES_ENABLED;
  return String(raw ?? "").trim().toLowerCase() === "true";
}
